import { colors } from "theme";

import Button, { ButtonProps } from "components/Button";
import { CallIcon } from "components/Icons/Call";

import { useEventTracking } from "hooks/useEventTracking";
import { externalRedirect } from "utils/redirect/ExternalRedirect";

export enum ContactMethod {
  PHONE = "phone",
}

type ButtonContactProps = ButtonProps & {
  url: string;
  contactMethod?: ContactMethod;
};

export const ContactButton = ({ url, contactMethod, children, ...buttonProps }: ButtonContactProps) => {
  const { trackEvent } = useEventTracking();

  const handleOnClick = () => {
    trackEvent({ name: "Contact Button Clicked" });
    externalRedirect(url);
  };

  return (
    <Button
      onClick={handleOnClick}
      typeVariant="primary"
      leftIcon={contactMethod === ContactMethod.PHONE ? <CallIcon color={colors.white} /> : null}
      style={{ width: "100%", alignSelf: "flex-start" }}
      {...buttonProps}
    >
      {children}
    </Button>
  );
};
